import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'brand-national-geographic',
  'IconBrandNationalGeographic',
  [['path', { d: 'M7 3h10v18h-10z', key: 'svg-0' }]],
);
